import { render, staticRenderFns } from "./ClientDirectoryList.vue?vue&type=template&id=3fc2ff24&scoped=true&"
import script from "./ClientDirectoryList.vue?vue&type=script&lang=js&"
export * from "./ClientDirectoryList.vue?vue&type=script&lang=js&"
import style0 from "./ClientDirectoryList.vue?vue&type=style&index=0&id=3fc2ff24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2ff24",
  null
  
)

export default component.exports